import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'linkify' })
export class LinkifyPipe implements PipeTransform {
  transform(link: string): string {
    return this.linkify(link);
  }

  private linkify(plainText): string {
    let replacedText;
    let replacePattern1;
    let replacePattern2;
    let replacePattern3;

    //URLs starting with http://, https://, or ftp://
    // eslint-disable-next-line no-useless-escape
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = plainText.replace(
      replacePattern1,
      '<a href="$1" target="_blank" class="underline cursor-pointer font-medium text-blue-600">$1</a>',
    );

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    // eslint-disable-next-line no-useless-escape
    replacePattern2 = /(^|[^\/])(www\.[^\s<>]+)/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '$1<a href="http://$2" target="_blank" class="underline cursor-pointer font-medium text-blue-600">$2</a>',
    );

    //Change email addresses to mailto:: links.
    // eslint-disable-next-line no-useless-escape
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1" class="underline cursor-pointer font-medium text-blue-600">$1</a>',
    );

    return replacedText;
  }
}

// Utility class to encapsulate LinkifyPipe logic to be used inside .ts files.
export class LinkifyPipeUtility {
  static transform(value: string): string {
    return LinkifyPipe.prototype.transform(value);
  }
}
